import { queryOptions } from "@tanstack/react-query";

import { unauthenticatedApi } from "@/api/api";
import type { GetApplicationStateOutputDto } from "@/types/codegen";

export const applicationStateQueryOptions = () =>
  queryOptions({
    queryKey: ["toggle", "application-state-turned-off"],
    queryFn: ({ signal }) =>
      unauthenticatedApi
        .get<GetApplicationStateOutputDto>(
          "/toggle/application-state-turned-off",
          {
            signal,
          },
        )
        .then((response) => response.data.data),
    staleTime: Infinity,
  });
